// extracted by mini-css-extract-plugin
export default {"main":"wybwkyM_bGswAPMli37J"};